export
const name: string = "Opaque";

export
const preproc: string = ``;

export
const declaration: string = `
    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)

    uniform SMaterial u_material;

    #elif defined(ALPHA_TRANSPARENCY) // alpha transparency depth pass

    uniform sampler2D u_texture;

    #endif
`;

export
const varyings: string = `
    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS) && !defined(CHUNK_LOD)
    varying lowp float  v_selected;
    #endif

    #if defined(PRIMITIVE_ID_PASS) && !defined(CHUNK_LOD)
    varying vec4 v_primitive_id;
    #endif

    #if defined(TEXTURED)
    varying vec2        v_tex_coord;
    #endif
`;

export
const implementation: string = `
    void main()
    {
    #ifdef CLIPPING_PLANE
        if (resolveClippingPlane()) {
            #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)

            gl_FragColor = vec4(clippingPlaneColor, 1.0);
            return;

            #endif
        }
    #endif

        // in chrome when chrome://gpu show that "Canvas: Software only, hardware acceleration unavailable"
        // then returning from function to struct members does not work
    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)

        #if defined(TEXTURED)

        SMaterial surfaceMat = applyTextureToSurface(u_material, v_tex_coord);

        #if !defined(CHUNK_LOD)
        if (v_selected > 0.5) {
            surfaceMat.ambient = u_selected_material_diffuse;
            surfaceMat.diffuse = clamp(surfaceMat.texColorReadOnly + vec3(0.4), 0.0, 1.0) * u_selected_material_diffuse;
            //surfaceMat.shading = 0;
        }
        #endif

        #else

        SMaterial surfaceMat = u_material;
        #if !defined(CHUNK_LOD)
        if (v_selected > 0.5) {
            surfaceMat.ambient = SELECTED_MATERIAL_AMBIENT;
            surfaceMat.diffuse = u_selected_material_diffuse;
            //surfaceMat.shading = 0;
        }
        #endif

        #endif

        #ifdef ALPHA_TRANSPARENCY

        // this is for alpha textures
        if (surfaceMat.alpha < 0.2) discard;

        #endif


    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS) && !defined(CHUNK_LOD)

        #if defined(HUD)
          gl_FragColor = vec4(surfaceMat.diffuse, surfaceMat.alpha);
        #else
          gl_FragColor = applyLighting(surfaceMat);
        #endif

        #if defined(XRAY)
        if (v_selected < 0.5) {
            gl_FragColor = vec4(vec3(1, 1, 1) * v_intensity, 1.0);
        }
        #endif
    #else
        gl_FragColor = applyLighting(surfaceMat);
    #endif

        #ifdef LOGDEPTH

        resolveLogarithmicDepth();

        #endif

    #endif

    #if defined(DEPTH_PASS)

        #ifdef ALPHA_TRANSPARENCY

        lowp vec4 color = texture2D(u_texture, v_tex_coord);
        if (color.a < 0.2) discard;

        #endif
        // THIS IS NOT HACK!!! the assigning of the gl_FragCoord.z value to z is needed for iPhone6 :-)
        float z = gl_FragCoord.z;
        gl_FragColor = floatToVec4(z);
    #endif

    #if defined(PRIMITIVE_ID_PASS) && !defined(CHUNK_LOD)

        gl_FragColor = v_primitive_id;

    #endif
    }
`;
